// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oyXW","content":"styles_content__XCZ0I","row":"styles_row__N9HJk","footer":"styles_footer__3FG0A","phraseLength":"styles_phraseLength__3aYbX"};